import { nl } from './nl';
import { hu } from './hu';
import { en } from './en';
import { de } from './de';
import { fr } from './fr';
import { es } from './es';
import { it } from './it';
import { pt } from './pt';
import { pl } from './pl';
import { tr } from './tr';
import { ar } from './ar';
import { ru } from './ru';
import { uk } from './uk';
import { zh } from './zh';
import { ja } from './ja';
import { ko } from './ko';
import type { Teksten } from './nl';

/**
 * De schermteksten in de taal die JIJ hebt gekozen.
 *
 * Kies je Duits, dan is de hele app Duits - niet alleen de vertaling. Twee
 * mensen in dezelfde kamer zien dus twee verschillende talen, en dat is precies
 * de bedoeling: de app is voor allebei even leesbaar.
 *
 * De keuze volgt de taal die je bij het binnenkomen aanwees, niet de instelling
 * van je browser. Wie zegt dat hij Duits spreekt, wil de app in het Duits -
 * ook op een telefoon die op Engels staat.
 */
const TALEN: Record<string, Teksten> = {
  nl,
  hu,
  en,
  de,
  fr,
  es,
  it,
  pt,
  pl,
  tr,
  ar,
  ru,
  uk,
  zh,
  ja,
  ko,
};

/** Talen die van rechts naar links lopen. */
const RECHTS_NAAR_LINKS = new Set(['ar']);

export function teksten(taalcode: string): Teksten {
  // 'de-DE' wordt 'de'. Onbekend valt terug op Engels en niet op Nederlands:
  // een gast die een taal koos die we niet hebben, leest eerder Engels.
  const kort = taalcode.split('-')[0] ?? '';
  return TALEN[kort] ?? en;
}

export function isRechtsNaarLinks(taalcode: string): boolean {
  return RECHTS_NAAR_LINKS.has(taalcode.split('-')[0] ?? '');
}

/**
 * De labels voor aanspreekvorm en sfeer, in de taal van de lezer.
 *
 * Ze staan NIET bij de talenlijst in shared/: die is gedeeld met de server, en
 * de server heeft geen taal. Wat een gast leest, hoort in de teksten te staan.
 */
export function aanspreekvormLabel(waarde: string, t: Teksten): string {
  switch (waarde) {
    case 'informeel':
      return t.vormInformeel;
    case 'formeel':
      return t.vormFormeel;
    default:
      return t.vormAutomatisch;
  }
}

export function sfeerLabel(waarde: string, t: Teksten): string {
  switch (waarde) {
    case 'zakelijk':
      return t.sfeerZakelijk;
    case 'officieel':
      return t.sfeerOfficieel;
    case 'vriendschappelijk':
      return t.sfeerVriendschappelijk;
    case 'partner':
      return t.sfeerPartner;
    default:
      return t.sfeerNeutraal;
  }
}

export type { Teksten };
